module.exports = __webpack_public_path__ + "static/img/excel.52faddc8.svg";